import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Icon, { Icons } from '../../../../components/Icon/Icon';
import { t } from '../../../../lang';
import HelperService from '../../../../services/HelperService';
import { appSlice } from '../../../../store/slices';

import './ExportTransactionsModal.scss';
import XLS from '../../../../components/Icon/components/XLS';
import PDF from '../../../../components/Icon/components/PDF';
import { createRootModal } from '../../RootModal';

const ExportTransactionsModal = createRootModal(({ handleClose }) => {
	// const { period } = useSelector(state => state.app.modal.outsideParams);

	const exportFileByType = type => {
		handleClose();
	};

	return (
		<div className='ExportTransactionsModal'>
			<div className='ExportTransactionsModal-item' onClick={() => exportFileByType('PDF')}>
				<div className='ExportTransactionsModal-item-icon'>
					<PDF />
				</div>
				<div className='ExportTransactionsModal-item-content'>
					<div className='ExportTransactionsModal-item-content-name'>Export PDF</div>
					<div className='ExportTransactionsModal-item-content-size'>5.3Mb</div>
				</div>
				<div className='ExportTransactionsModal-item-arrow'>
					<Icon type={Icons.ARROW_CHEVRON} />
				</div>
			</div>

			<div className='ExportTransactionsModal-item' onClick={() => exportFileByType('PDF')}>
				<div className='ExportTransactionsModal-item-icon'>
					<XLS />
				</div>
				<div className='ExportTransactionsModal-item-content'>
					<div className='ExportTransactionsModal-item-content-name'>Export XLS</div>
					<div className='ExportTransactionsModal-item-content-size'>5.3Mb</div>
				</div>
				<div className='ExportTransactionsModal-item-arrow'>
					<Icon type={Icons.ARROW_CHEVRON} />
				</div>
			</div>
		</div>
	);
});

export default ExportTransactionsModal;
